import Link from "next/link";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import BoxContainer from "../Reusables/BoxContainer";
import { count, removeAfterSpace } from "../../config/helpers";
import styles from "./Testimonials.module.css";

const Testimonials = (props) => {
    const {
        testimonials,
        loadMore,
        template_page_settings,
    } = props;

    const { template_settings } = useSelector((state) => state.globalReducer);
    const accentStyle = {
        "--testimonial-accent": template_settings.primary_colour,
        "--testimonial-accent-contrast": template_settings.primary_colour_contrast_text,
    };

    return (
        <BoxContainer template_page_settings={template_page_settings} className="mb-6 mt-3" style={accentStyle}>
            <h1 className={styles.title}>Testimonials - What Our Customers Say</h1>
            <p className={styles.intro}>{`At ${process.env.brand.brand_name} we value all the feedback we receive from our clients. Below are a selection of our testimonials.`}</p>
            {count(testimonials) > 0 ? (
                <>
                    <ul className={styles.list}>
                        {testimonials.map((testimonial, index) => (
                            <li key={index}>
                                <figure className={styles.bubble}>
                                    <blockquote className={styles.quote}>{testimonial.content}</blockquote>
                                    <figcaption className={styles.attribution}>
                                        {dayjs(testimonial.date).format("DD/MM/YYYY")} - {removeAfterSpace(testimonial.customer)}
                                    </figcaption>
                                </figure>
                            </li>
                        ))}
                    </ul>
                    {loadMore.nextVisible && (
                        <div className={styles.loadMore}>
                            <Link
                                href={`/testimonials?show=${loadMore.nextVisible}`}
                                className={styles.loadMoreButton}
                                scroll={false}
                                prefetch={false}
                            >
                                Load More
                            </Link>
                        </div>
                    )}
                </>
            ) : (
                <p>Sorry! No Testimonials have been found.</p>
            )}
        </BoxContainer>
    );
};

export default Testimonials;
